(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl-contact-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-clcx]').forEach(section => {
        if (section.dataset.clcxReady === 'true') return;
        section.dataset.clcxReady = 'true';
        const topic = section.querySelector('[data-clcx-topic]');
        const hint = section.querySelector('[data-clcx-topic-hint]');
        if (topic && hint) {
          const updateHint = () => {
            const option = topic.options[topic.selectedIndex];
            if (option && option.dataset.hint) hint.textContent = option.dataset.hint;
          };
          topic.addEventListener('change', updateHint);
          const requested = new URLSearchParams(window.location.search).get('topic');
          const allowed = Array.from(topic.options).find(option => option.dataset.topic === requested);
          if (allowed) topic.value = allowed.value;
          updateHint();
        }
        const result = section.querySelector('[data-clcx-result]');
        if (result) result.focus({ preventScroll: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-delivery-editorial"] && !Shopify.designMode) return;
  try {
    
function clShipInit(scope) {
  scope.querySelectorAll('[data-clship]').forEach((root) => {
    if (root.dataset.clshipBound) return;
    root.dataset.clshipBound = 'true';
    const select = root.querySelector('[data-clship-select]');
    const result = root.querySelector('[data-clship-result]');
    if (!select || !result) return;
    select.addEventListener('change', () => {
      root.querySelectorAll('[data-clship-rate].is-selected').forEach((row) => row.classList.remove('is-selected'));
      if (!select.value) { result.hidden = true; return; }
      let price;
      let time;
      let service;
      if (select.value === '0') {
        price = root.dataset.ukPrice;
        time = root.dataset.ukTime;
        service = root.dataset.ukService;
      } else {
        const row = root.querySelector('[data-clship-rate="' + select.value + '"]');
        if (!row) { result.hidden = true; return; }
        price = row.querySelector('[data-clship-price]').textContent;
        time = row.querySelector('[data-clship-time]').textContent;
        service = row.querySelector('[data-clship-service]').textContent;
        row.classList.add('is-selected');
      }
      result.querySelector('[data-clship-result-country]').textContent = select.options[select.selectedIndex].textContent;
      result.querySelector('[data-clship-result-price]').textContent = price;
      result.querySelector('[data-clship-result-time]').textContent = time;
      result.querySelector('[data-clship-result-service]').textContent = service;
      result.hidden = false;
    });
  });
}
clShipInit(document);
document.addEventListener('shopify:section:load', (event) => clShipInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-footer-editorial"]) return;
  try {
    
function clFooterInit(scope) {
  scope.querySelectorAll('[data-cl-footer]').forEach((root) => {
    if (root.dataset.clFooterBound) return;
    root.dataset.clFooterBound = 'true';
    const media = window.matchMedia('(max-width: 749px)');
    const panels = Array.from(root.querySelectorAll('[data-cl-footer-panel]'));
    const setLayout = () => {
      panels.forEach((panel) => {
        panel.open = !media.matches;
        const summary = panel.querySelector('summary');
        if (summary) summary.tabIndex = media.matches ? 0 : -1;
      });
    };
    panels.forEach((panel) => {
      const summary = panel.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (event) => {
        if (!media.matches) event.preventDefault();
      });
    });
    setLayout();
    if (typeof media.addEventListener === 'function') media.addEventListener('change', setLayout);
    else media.addListener(setLayout);
    const cookiePreferences = root.querySelector('[data-cl-footer-cookies]');
    if (cookiePreferences) {
      cookiePreferences.addEventListener('click', (event) => {
        if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
          event.preventDefault();
          window.Cookiebot.renew();
        }
      });
    }
    const toTop = root.querySelector('[data-cl-footer-top]');
    if (toTop) {
      toTop.addEventListener('click', (event) => {
        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const main = document.getElementById('MainContent');
        if (main) main.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    }
  });
}
clFooterInit(document);
document.addEventListener('shopify:section:load', (event) => clFooterInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-policy-editorial"] && !Shopify.designMode) return;
  try {
    
function clLegalInit(scope) {
  scope.querySelectorAll('[data-cllegal]').forEach((root) => {
    if (root.dataset.cllegalBound) return;
    root.dataset.cllegalBound = 'true';
    const status = root.querySelector('[data-cllegal-cookie-status]');
    const buttons = Array.from(root.querySelectorAll('[data-cllegal-cookies]'));
    let pending = false;
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
          window.Cookiebot.renew();
          if (status) status.textContent = '';
          return;
        }
        if (pending) return;
        pending = true;
        if (status) status.textContent = root.dataset.cookieLoading;
        buttons.forEach((item) => { item.disabled = true; });
        if (!document.getElementById('Cookiebot')) {
          const script = document.createElement('script');
          script.id = 'Cookiebot';
          script.src = 'https://consent.cookiebot.com/uc.js';
          script.setAttribute('data-cbid', '4916494c-19dd-46a5-a6a2-356f96efe9f4');
          script.async = true;
          document.head.appendChild(script);
        }
        let attempts = 0;
        const timer = window.setInterval(() => {
          attempts += 1;
          if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
            window.clearInterval(timer);
            pending = false;
            buttons.forEach((item) => { item.disabled = false; });
            if (status) status.textContent = '';
            window.Cookiebot.renew();
          } else if (attempts >= 48) {
            window.clearInterval(timer);
            pending = false;
            buttons.forEach((item) => { item.disabled = false; });
            if (status) status.textContent = root.dataset.cookieUnavailable;
          }
        }, 250);
      });
    });
    if ('IntersectionObserver' in window) {
      const links = Array.from(root.querySelectorAll('.cllegal-contents a[href^="#s"]'));
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => {
            if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-15% 0px -65% 0px' });
      root.querySelectorAll('.cllegal-body section[id]').forEach((section) => observer.observe(section));
    }
  });
}
clLegalInit(document);
document.addEventListener('shopify:section:load', (event) => { clLegalInit(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-print-house"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      const roots = scope.matches?.('[data-cl-print-house]') ? [scope] : scope.querySelectorAll('[data-cl-print-house]');
      roots.forEach((root) => {
        if (root.dataset.clPrintReady) return;
        const track = root.querySelector('[data-cl-print-track]');
        const cards = Array.from(root.querySelectorAll('[data-cl-print-card]'));
        const controls = root.querySelector('[data-cl-print-controls]');
        if (!track || !controls || cards.length < 2) return;
        root.dataset.clPrintReady = 'true';
        const previous = root.querySelector('[data-cl-print-prev]');
        const next = root.querySelector('[data-cl-print-next]');
        const current = root.querySelector('[data-cl-print-current]');
        let index = 0;
        let frame = 0;
        const update = () => {
          const start = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
          let nearest = Infinity;
          cards.forEach((card, position) => {
            const distance = Math.abs(card.getBoundingClientRect().left - start);
            if (distance < nearest) { nearest = distance; index = position; }
          });
          current.textContent = String(index + 1).padStart(2, '0');
          previous.disabled = index === 0;
          next.disabled = index === cards.length - 1;
        };
        const move = (direction) => {
          const destination = Math.max(0, Math.min(cards.length - 1, index + direction));
          const card = cards[destination];
          const padding = parseFloat(getComputedStyle(track).paddingLeft);
          const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - padding;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        });
        track.addEventListener('scroll', () => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(update);
        }, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        controls.hidden = false;
        update();
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('related-products');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => { console.error(e); });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('related-products', RelatedProducts);

  } catch(e) { console.error(e); }
})();
})();
